<div class="modal-container">
  <div class="modal-header d-flex justify-content-between align-items-center">
    <h2 mat-dialog-title>Descargar certificado</h2>

    <button type="button" (click)="cerrar()" class="close-btn" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content [formGroup]="form">
    <div class="modal-body">

      <p class="instruccion">
        Para descargar tu certificado, ingresa tu número de documento.
      </p>

      <div class="form-row">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Número de documento</mat-label>

          <input
            matInput
            formControlName="documento"
            autocomplete="off"
            inputmode="numeric"
            placeholder="Ej. 1032456789"
            (keyup.enter)="descargar()"
          />

          <mat-error *ngIf="form.get('documento')?.hasError('required')">
            Este campo es obligatorio.
          </mat-error>

          <mat-error *ngIf="form.get('documento')?.hasError('minlength')">
            El documento es muy corto.
          </mat-error>
        </mat-form-field>

        <div *ngIf="errorMsg" class="error-box" role="alert" aria-live="polite">
          <mat-icon class="error-icon">error</mat-icon>
          <span>{{ errorMsg }}</span>
        </div>
      </div>

      <p class="helper-text">
        Si el documento no coincide con el certificado, no podrás descargarlo.
      </p>

    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="center" class="pb-4">
    <button
      mat-raised-button
      color="primary"
      [disabled]="form.invalid || loading"
      (click)="descargar()"
    >
      {{ loading ? 'Validando...' : 'Descargar' }}
    </button>
  </mat-dialog-actions>
</div>